import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingMethodType } from '../../constants/hearing-method.type';
import { MatTableDataSource } from '@angular/material/table';
import { AssociateSystemMaterialModel } from '../../models/associate-system-material.model';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'jsg-hearing-associate-materials-system-view',
  templateUrl: './hearing-associate-materials-system-view.component.html',
  styleUrls: ['./hearing-associate-materials-system-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HearingAssociateMaterialsSystemViewComponent {
  readonly formPath = 'lawyer.associateMaterials.forms.fromSystemMaterial';
  private data: AssociateSystemMaterialModel[];
  get tableData(): AssociateSystemMaterialModel[] {
    return this.data;
  }
  @Input()
  set tableData(value: AssociateSystemMaterialModel[]) {
    this.data = value;
    this.dataSource = new MatTableDataSource(value);

    this.createFromSystemMaterialFormArray(value);
  }
  @Input() form: FormGroup;

  @Output() associateMaterials = new EventEmitter();
  @Output() selectUploadTab = new EventEmitter();
  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();

  displayedColumns: string[] = [
    'select',
    'submittedBy',
    'materialType',
    'dateFiled',
    'fileName',
  ];
  dataSource = new MatTableDataSource<any>();

  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;
  public HearingMethodType = HearingMethodType;

  get fromSystemMaterialFormAray(): FormArray {
    return this.form.get('fromSystemMaterials') as FormArray;
  }

  constructor(private fb: FormBuilder) {}

  private createSingleItem = (
    systemMaterial: AssociateSystemMaterialModel
  ): FormGroup => {
    let formGroup = this.fb.group({
      selected: [
        { value: false, disabled: systemMaterial.isAssociated ? true : false },
        Validators.required,
      ],
      id: [{ value: systemMaterial.id, disabled: true }, Validators.required],
      materialTypeId: [
        { value: systemMaterial.materialTypeId, disabled: true },
        Validators.required,
      ],
      isAssociated: [
        { value: systemMaterial.isAssociated, disabled: true },
        Validators.required,
      ],
    });
    return formGroup;
  };

  private createFromSystemMaterialFormArray = (
    systemMaterial: AssociateSystemMaterialModel[]
  ) => {
    systemMaterial?.forEach((item) => {
      this.fromSystemMaterialFormAray.push(this.createSingleItem(item));
    });
  };

  public onAssociateMaterials = () => {
    this.associateMaterials.emit();
  };

  public onSelectUploadTab = () => {
    this.selectUploadTab.emit();
  };

  public onOpenFile = (docToOpen: AssociateSystemMaterialModel) => {
    this.openFile.emit(docToOpen.document);
  };

  public onRowClick = (
    rowData: AssociateSystemMaterialModel,
    rowIndex: number
  ) => {
    if (!rowData.isAssociated) {
      const selectCheckBoxControl = this.fromSystemMaterialFormAray
        .at(rowIndex)
        .get('selected');
      selectCheckBoxControl.setValue(!selectCheckBoxControl.value);
    }
  };
}
